import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//import { User } from '@/_models';

@Injectable({ providedIn: 'root' })
export class IntermediateSaveService {
  isFromInterSave = false;
  isFromInterNew = false;
  draftJsonData: any;
  reqTrn: string;
  constructor(private http: HttpClient) {}

  setJasonData(data: any): void {
    this.draftJsonData = data;
  }
  getJasonData(): any {
    return this.draftJsonData;
  }
  setReqTrnId(reqTrn: string): void {
    this.reqTrn = reqTrn;
  }
  getReqTrnId(): string {
    return this.reqTrn;
  }
}
